var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiTextTransformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_669_2555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 5.5V7.72881H2V5.50659L18.5 5.5ZM2 18.8399H12V16.6177H2V18.8399ZM2 13.2844H22V11.0621H2V13.2844Z",
    fill: "#1C1356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0852 6.86666C20.2063 6.95262 20.351 6.99898 20.4995 6.99937C20.648 6.99976 20.793 6.95415 20.9145 6.86881C21.0233 6.79126 21.1089 6.68517 21.1611 6.56212L21.4939 5.54728C21.5753 5.30267 21.7126 5.08041 21.8949 4.89812C22.0772 4.71584 22.2995 4.57855 22.5441 4.49716L23.5217 4.17862C23.662 4.12914 23.7835 4.03736 23.8695 3.91592C23.9554 3.79449 24.0016 3.64939 24.0016 3.50062C24.0016 3.35185 23.9554 3.20675 23.8695 3.08531C23.7835 2.96388 23.662 2.8721 23.5217 2.82262L22.5255 2.50139C22.2817 2.41977 22.0601 2.28277 21.8781 2.10113C21.6962 1.91949 21.5588 1.69816 21.4767 1.4545L21.1592 0.477352C21.1099 0.336996 21.018 0.215499 20.8965 0.129735C20.7744 0.0452577 20.6295 0 20.4811 0C20.3327 0 20.1878 0.0452577 20.0658 0.129735C19.9421 0.217352 19.8491 0.34171 19.8 0.48516L19.4788 1.47254C19.3972 1.71 19.2628 1.92587 19.0858 2.10393C18.9087 2.28199 18.6937 2.4176 18.4567 2.50058L17.4801 2.81777C17.339 2.86746 17.217 2.95989 17.1309 3.08219C17.0449 3.2045 16.9991 3.35059 17 3.50013C17.0009 3.64967 17.0484 3.79521 17.1359 3.91648C17.2234 4.03776 17.3465 4.12873 17.4881 4.17673L18.454 4.49042C18.6987 4.57258 18.9209 4.71043 19.1033 4.89313C19.2856 5.07583 19.423 5.29838 19.5046 5.54324L19.8224 6.51877C19.8716 6.65906 19.9637 6.78076 20.0852 6.86666Z",
    fill: "#1C1356"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_669_2555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiTextTransformation);
export default __webpack_public_path__ + "static/media/ai-text-transformation.d84da8bf.svg";
export { ForwardRef as ReactComponent };